import React, { useEffect, useState } from "react";
import "./lists.css";
import classNames from "classnames";
import axios from "axios";

export default function Lists() {
  const [open, setOpen] = useState(false);
  useEffect(() => {}, [open]);
  const [up, setUp] = useState([]);
  const [down, setDown] = useState([]);
  useEffect(() => {
    axios
      .get("http://www.itemev.com/home/Navigation/cseMain")
      .then((response) => {
        setUp(response.data.slice(0, 27));
        setDown(response.data.slice(27, 45));
      });
  }, []);

  const [green, setGreen] = useState([]);
  useEffect(() => {
    axios
      .get("http://www.itemev.com/home/Navigation/variety130main")
      .then((response) => {
        setGreen(response.data);
      });
  }, []);

  return (
    <div>
      <div className="lists">
        {/* 上部分 */}
        <div className="lists-top">
          <ul>
            {up !== [] && (
              <>
                {up.map((list) => {
                  return (
                    <li key={list.number}>
                      {list.img !== "" && (
                        <img src={list.img} alt="" className="lists-logo" />
                      )}
                      <span
                        className={classNames("lists-red", {
                          "lists-span": list.img === "",
                        })}
                        onClick={() => {
                          window.open(list.url);
                        }}
                      >
                        {list.name}
                      </span>
                    </li>
                  );
                })}
              </>
            )}
          </ul>
        </div>
        {/* 下部分 */}
        <div className="lists-down">
          <ul>
            {down !== [] && (
              <>
                {down.map((item) => {
                  return (
                    <li key={item.number}>
                      {item.img !== "" && (
                        <img src={item.img} alt="" className="lists-logo" />
                      )}
                      <span
                        className={classNames({
                          "lists-span": item.img === "",
                        })}
                        onClick={() => {
                          window.open(item.url);
                        }}
                      >
                        {item.name}
                      </span>
                    </li>
                  );
                })}
              </>
            )}
          </ul>
        </div>
        {/* 点击展开 */}
        <div
          className={classNames("lists-click", {
            "lists-click-none": open === true,
          })}
        >
          <span
            onClick={() => {
              setOpen(true);
            }}
          >
            点击展开
          </span>
        </div>
      </div>

      {/* 点击收起 */}
      <div
        className={classNames("lists-open", {
          "lists-click-none": open === false,
        })}
      >
        {/* 数据列表 */}
        <div className="listsOpen">
          {green !== [] && (
            <>
              {green.map((todo) => {
                return (
                  <ul className="lists-open-list" key={todo.name}>
                    <li>
                      <span className="color-green">{todo.name}</span>
                    </li>
                    {todo.list.map((lis) => {
                      return (
                        <li key={lis.name}>
                          <span
                            className={classNames({
                              "color-orange": lis.highlight === 1,
                            })}
                            onClick={() => {
                              window.open(lis.url);
                            }}
                          >
                            {lis.name}
                          </span>
                        </li>
                      );
                    })}

                    <li>
                      <span className="color-gray"></span>
                    </li>
                  </ul>
                );
              })}
            </>
          )}
        </div>

        {/* 收起按钮 */}
        <div className="lists-click-close">
          <span
            onClick={() => {
              setOpen(false);
            }}
          >
            点击收起
          </span>
        </div>
      </div>
    </div>
  );
}
